import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import CssBaseline from '@material-ui/core/CssBaseline';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Link from '@material-ui/core/Link';
import IconButton from '@material-ui/core/IconButton';
import NavMenu from 'components/NavMenu';
import Paper from '@material-ui/core/Paper';
import ApiService from '../../services/ApiService';
import OnSiteEvaluationsContainer from 'app/containers/OnSiteEvaluationsContainer';
import OnSiteEvaluationsCalContainer from 'app/containers/OnSiteEvaluationsCalContainer';
import TextEvents from 'app/components/TextEvents';
import Grid from '@material-ui/core/Grid';
import Highlighter from 'react-highlight-words';
import { Table, Drawer, Button, Tabs, Modal, Input, Icon, Row, Col, Tooltip, DatePicker } from 'antd'
import { useStyles, styles } from './OnSiteEvaluationsScreenStyles';

import { getEvaluationsFiltersFtF, getEvaluationsCalFiltersFtF, getAsignedEmployeesFtF, printEvaluationFtF, editEvaluationCalFtF, getEvaluationsCalFtF_ } from 'app/actions/OnSiteEvaluationsActions';

import OnSiteEvaluationForm from 'app/components/OnSiteEvaluationsForm';
import OnSiteEvaluationsCalForm from 'app/components/OnSiteEvaluationsCalForm';

import moment from 'moment';
//import { clearBookmark, clearBookmarkPreview, fetchBookmark } from 'app/actions/BookmarkActions';

const { confirm } = Modal;
const { TextArea } = Input;

export default function OnSiteEvaluationsScreen(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { TabPane } = Tabs;
    const { idSubdirection, employeeId } = useSelector((state) => state.Auth.employeeById);
    const [filter, setFilter] = useState([]);
    const [filterCal, setFilterCal] = useState([]);
    const [pagination, setPagination] = useState({ defaultCurrent: 1, defaultPageSize: 25, pageSize: 25, total: 0, showSizeChanger: true, pageSizeOptions: ['25', '50', '100'], showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros` });
    const [paginationCal, setPaginationCal] = useState({ defaultCurrent: 1, defaultPageSize: 25, pageSize: 25, total: 0, showSizeChanger: true, pageSizeOptions: ['25', '50', '100'], showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros` });
    const [sorter, setSorter] = useState({});
    const [sorterCal, setSorterCal] = useState({});
    const [formData, setFormData] = useState({});
    const [formDataCal, setFormDataCal] = useState({});
    const [PDFData, setPDFData] = useState({});
    const [isVisible, setVisible] = useState();
    const [activeKey, setTabBar] = useState('1');
    const [idTest, setIdTest] = useState({});
    const [usersAsigned, setUsersAsigned] = useState([])
    const [userAdd, setUserAdd] = useState([])

    const [dateCal, setDateCal] = useState('');
    const [dateRCal, setDateRCal] = useState(null);
    const [idCal, setIdCal] = useState('');
    const [idCommu, setIdCommu] = useState(0)
    const [titleCal, setTitleCal] = useState('')
    const [openCal, setOpenCal] = useState(false);
    const [estadoCal, setEstadoCal] = useState(0);

    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const [selectedRowKeysFile, setSelectedRowKeysFile] = useState([]);
    const [selectedRowsFile, setSelectedRowsFile] = useState([]);
    const [selectedRowKeysAvailableFile, setSelectedRowKeysAvailableFile] = useState([]);
    const [selectedRowsAvailableFile, setSelectedRowsAvailableFile] = useState([]);

    const [employeesAssigFile, setEmployeesAssigFile] = useState([]);
    const [selectedRowsFileAssig, setSelectedRowsFileAssig] = useState([]);
    const [selectedRowKeysFileAssig, setSelectedRowKeysFileAssig] = useState([]);
    const [selectedRowsAvailableFileAssig, setSelectedRowsAvailableFileAssig] = useState([]);
    const [selectedRowKeysAvailableFileAssig, setSelectedRowKeysAvailableFileAssig] = useState([]);

    const [evaLength, setEvaLength] = useState(0);
    const [resLength, setResLength] = useState(0);

    const [printing, setPrinting] = useState(false);
    const [evaluating, setEvaluating] = useState(false);

    const {
        listEmployeesByIdEmployee,
        isLoadListEmployeesById
    } = useSelector(state => state.CommunicationProgram);

    let [showModal, setShowModal] = useState(false);
    useEffect(() => {
        dispatch(getEvaluationsFiltersFtF({
            EmployeeId: employeeId,
            SubdirectionId: idSubdirection
        }));
        dispatch(getEvaluationsCalFiltersFtF({
            EmployeeId: employeeId,
            SubdirectionId: idSubdirection //10
        }))
        //dispatch(getTrainingSelect(employeeId));

    }, [dispatch])

    const showModalSet = async (model) => {

        setUserAdd([]);
        let { data } = await getAsignedEmployeesFtF({
            idCourse: model.idCourse,
            idDiffussion: model.idDiffusion
        })
        setUsersAsigned(data.length > 0 ? data : []);

        setShowModal(model.visible)
    }

    const showModalCal = (item) => {
        let { title, data, estado } = item;
        setTitleCal(`${title} - ${data.testFolio}`)
        setIdCal(data.idPresentialEvaluation)
        setIdCommu(data.idCommunication)
        setEstadoCal(estado);
        setOpenCal(true);
    }

    const saveEdition = async () => {
        setEvaluating(true)

        dispatch(editEvaluationCalFtF({
            idPresentialEvaluation: idCal,
            idEstatus: estadoCal,
            idCommunication: idCommu,
            idApprover: employeeId,
            dateApply: dateCal
        }, {
            EmployeeId: employeeId,
            SubdirectionId: idSubdirection, //10
            DateApply: (formDataCal.dateSel === undefined) ? '' : formDataCal.dateSel,
            Fichas: (formDataCal.employeeSel === undefined) ? '' : formDataCal.employeeSel,
            TestFolio: (formDataCal.testFolioSel === undefined) ? '' : formDataCal.testFolioSel,
            IdPresentialEvaluation: (formDataCal.preEvaluationSel === undefined) ? '' : formDataCal.preEvaluationSel,
            Pernocta: (formDataCal.pernoctaSel === undefined) ? '' : formDataCal.pernoctaSel,
            CourseFolio: (formDataCal.folioSelected === undefined) ? '' : formDataCal.folioSelected,
            sortColumn: sorterCal.field,
            sortDir: sorterCal.order,
            offset: 0,
            limit: paginationCal.pageSize
        },
        succedCal))

    }

    const succedCal = () => {
        setEvaluating(false)
        setTitleCal('')
        setIdCal('')
        setIdCommu(0)
        setEstadoCal(0);
        setDateCal('');
        setOpenCal(false);
        setDateCal('');
        setDateRCal(null)
       
    }



    const downloadFile = (blob, fileName) => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        document.body.append(link);
        link.click();
        link.remove();
        window.addEventListener('focus', e => URL.revokeObjectURL(link.href), { once: true });
    };

    const dataSourceFile = usersAsigned.filter(x => !userAdd.map(y => y.employeeId).includes(x.employeeId)).map( //Empleados por ficha asignados
    (record) => {
        return {
            'key': record.employeeId,
            'fullName': record.fullName,
            'employeeId': record.employeeId,
            'categoryName': record.categoryName,
            'companyName': record.companyName
        }
    }
    )

    const dataSourceFileAssig = userAdd.map( //Empleados por ficha asignados
    (record) => {
        return {
            'key': record.employeeId,
            'fullName': record.fullName,
            'employeeId': record.employeeId,
            'categoryName': record.categoryName,
            'companyName': record.companyName
        }
    }
)



    //Genera la estructura de búsqueda
    const getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    placeholder={`Buscar...`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                    type="primary"
                    onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    icon="search"
                    size="small"
                    style={{ width: 90, marginRight: 8 }}
                >
                    Buscar
                </Button>
                <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                    Limpiar
                </Button>
            </div>
        ),
        filterIcon: filtered => (
            <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
        render: text =>
            searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                    searchWords={[searchText]}
                    autoEscape
                    textToHighlight={text.toString()}
                />
            ) : (
                text
            ),
    });

    const onSelectChangeAvailableFile = (selectedRowKeys, selectedRows) => {
        setSelectedRowsAvailableFile(selectedRows);
        setSelectedRowKeysAvailableFile(selectedRowKeys);
        setSelectedRowsFile(selectedRows);
        setSelectedRowKeysFile(selectedRowKeys);
    }

    const rowSelectionAvailableFile = {
        selectedRowKeys: selectedRowKeysFile,
        selectedRows: selectedRowsFile,
        onChange: onSelectChangeAvailableFile
    }

    const columnsCategoryFile = [
        {
            title: 'Nombre',
            dataIndex: 'fullName',
            key: 'fullName',
            ellipsis: true,
            width: 300,
            ...getColumnSearchProps('fullName')
        },
        {
            title: 'Ficha',
            dataIndex: 'employeeId',
            key: 'employeeId',
            ellipsis: true,
            width: 100,
            ...getColumnSearchProps('employeeId')
        },
        {
            title: 'Puesto',
            dataIndex: 'categoryName',
            key: 'categoryName',
            ellipsis: true,
            width: 170,
            ...getColumnSearchProps('categoryName')
        },
        {
            title: 'Compañia',
            dataIndex: 'companyName',
            key: 'companyName',
            ellipsis: true,
            width: 170,
            ...getColumnSearchProps('companyName')
        }
    ];

    const columnsCategory = [
        {
            title: 'Nombre',
            dataIndex: 'fullName',
            key: 'fullName',
            ellipsis: true,
            width: 300,
            ...getColumnSearchProps('fullName')
        },
        {
            title: 'Ficha',
            dataIndex: 'employeeId',
            key: 'employeeId',
            ellipsis: true,
            width: 100,
            ...getColumnSearchProps('employeeId')
        },
        {
            title: 'Puesto',
            dataIndex: 'categoryName',
            key: 'categoryName',
            ellipsis: true,
            width: 170,
            ...getColumnSearchProps('categoryName')
        },
        {
            title: 'Compañia',
            dataIndex: 'companyName',
            key: 'companyName',
            ellipsis: true,
            width: 170,
            ...getColumnSearchProps('companyName')
        }
    ];

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    }

    const handleReset = clearFilters => {
        clearFilters();
        setSearchText('');
    };

    const assignEmployeeFile = () => {
        setUserAdd([...userAdd, ...selectedRowsAvailableFile]);
        setSelectedRowsAvailableFile([]);
        setSelectedRowKeysAvailableFile([]);
        setSelectedRowsFile([]);
        setSelectedRowKeysFile([]);
    }

    const onSelectChangeAvailableFileAssig = (selectedRowKeys, selectedRows) => {
        setSelectedRowsAvailableFileAssig(selectedRows);
        setSelectedRowKeysAvailableFileAssig(selectedRowKeys);
        setSelectedRowsFileAssig(selectedRows);
        setSelectedRowKeysFileAssig(selectedRowKeys);
    }

    const removeEmployeeFile = () => {
        setUserAdd(userAdd.filter(x => !selectedRowKeysAvailableFileAssig.includes(x.employeeId)))
        setSelectedRowsAvailableFileAssig([]);
        setSelectedRowKeysAvailableFileAssig([]);
        setSelectedRowsFileAssig([]);
        setSelectedRowKeysFileAssig([]);
    }



    const rowSelectionAvailableFileAssig = {
        selectedRowKeys: selectedRowKeysFileAssig,
        selectedRows: selectedRowsFileAssig,
        onChange: onSelectChangeAvailableFileAssig
    }

    const [height, setHeight] = useState(window.innerHeight);

    const ConfirmModal = () => {

        var payload = {
            "idDiffusion": idTest.idDiffusion,
            "idCourse": idTest.idCourse,
            "courseCode": idTest.courseCode,
            "courseName": idTest.courseName,
            "idCommunicationProgram": idTest.idCommunicationProgram,
            "idEmployee": dataSourceFileAssig.map((a) => { return { ficha: a.employeeId } })
        }

        return (
            confirm({
                title: `Se van a imprimir ${dataSourceFileAssig.length} ${dataSourceFileAssig.length > 1 ? 'evaluaciones' : 'evaluación'}?`,
                okText: 'Imprimir',
                okType: 'danger',
                cancelText: 'Cancelar',
                onOk() {
                    setPrinting(true);
                    // dispatch(printEvaluationFtF(payload, idTest.courseFolio));
                    ApiService.postPrintEvaluation(payload).then(
                        (result) => {
                            const blob = new Blob([result], { type: 'application/pdf' });
                            downloadFile(blob, `Evaluacion_${idTest.courseFolio}.pdf`);
                            setShowModal(false); setUsersAsigned([]);
                            setPrinting(false)
                        },
                        (error) => {
                            setPrinting(false)
                            throw ({ error: error, message: 'Ops! export has failed' });
                        }
                    )
                },
                onCancel() {
                },
            })
        )
    }

    window.addEventListener('resize', () => {
        setHeight(window.innerHeight);
    });

    return (
        <div className={classes.root}>
            <NavMenu SelectedIndex={props.history.location.pathname} isAdmin={true} header='Evaluaciones Presenciales Impresión/Carga de Resultados' isCommunicationStatus={false} />
            <CssBaseline />
            <div className={classes.content}>
                <div className={classes.appBarSpacer} />
                <div elevation={0} style={styles.titleBox}>
                    <Breadcrumbs aria-label='Breadcrumb'>
                        <Link color='inherit' disabled>
                            Administración
                        </Link>
                        <TextEvents
                            text={'Evaluaciones Presenciales Impresión/Carga de Resultados'}
                            color='cotemar'
                            size='subtitle'
                            weight='bold'
                        />
                    </Breadcrumbs>
                </div>
                <Tabs tabBarStyle={{ margin: 0 }}
                    type='card'
                    activeKey={activeKey}
                    defaultActiveKey='1'
                    className={classes.tabContainer}
                    onChange={tab => setTabBar(tab)}
                >
                    <TabPane tab='Imprimir' key='1'>
                        <Paper className={classes.paper} key='1'>
                            <OnSiteEvaluationForm
                                filter={filter}
                                setFilter={setFilter}
                                setTab={setTabBar}
                                pagination={pagination}
                                sorter={sorter}
                                formData={formData}
                                setFormData={setFormData}
                     
                            ></OnSiteEvaluationForm>
                            <div style={styles.baseVerticalMargin}>
                                <OnSiteEvaluationsContainer
                                    classes={classes}
                                    setTab={setTabBar}
                                    setIdTest={setIdTest}
                                    filter={filter}
                                    sorter={sorter}
                                    setSorter={setSorter}
                                    pagination={pagination}
                                    setPagination={setPagination}
                                    formData={formData}
                                    setShowModal={showModalSet}
                                >
                                    {(params) => {
                                        return (
                                            <div>
                                                <Table
                                                    useFixedHeader={true}
                                                    loading={params.isLoading}
                                                    rowKey={item => String(item.idCommunicationProgram)}
                                                    columns={params.cols}
                                                    dataSource={params.evaluations}
                                                    onChange={params.handleTableChange}
                                                    pagination={pagination}
                                                    scroll={{ x: "min-content", y: (height - 395) }}
                                                    size={"small"}
                                                />
                                            </div>
                                        )
                                    }}
                                </OnSiteEvaluationsContainer>
                            </div>

                            <Modal
                                visible={showModal}
                                onCancel={() => {setShowModal(false); setUsersAsigned([]); }}
                                width={'900px'}
                                centered={true}
                                footer={[
                                    <Button disabled={dataSourceFileAssig.length === 0} key="submit" type="primary" onClick={() => {
                                        ConfirmModal();
                                    }} loading={printing}>
                                        Imprimir
                                    </Button>,
                                    <Button key="back" type="danger" ghost onClick={() => { setShowModal(false); setUsersAsigned([]); }}>
                                        Cancelar
                                    </Button>
                                ]}
                            >
                                <Tabs type='card' tabBarStyle={{ margin: 0 }} activeKey={'1'} defaultActiveKey='1'>
                                    <TabPane tab='Por Ficha' key='1'>
                                        <Paper className={classes.paper} key='2'>
                                            <Grid container direction="row">
                                                <Grid item xs={12}>
                                                    <TextEvents
                                                        text={'Colaboradores disponibles'}
                                                        color='cotemar'
                                                        size='label'
                                                        weight='bold'
                                                    />
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Table
                                                        columns={columnsCategoryFile}
                                                        dataSource={dataSourceFile}
                                                        scroll={{ y: 150 }}
                                                        rowSelection={rowSelectionAvailableFile}
                                                        size="small"
                                                    />
                                                </Grid>
                                            </Grid>

                                            <Row gutter={[12, 8]}>
                                                <Col span={12} align="right">
                                                    <Tooltip disabled={rowSelectionAvailableFile.length === 0} placement="bottom" title={'Asignar colaborador'}>
                                                        <IconButton className={classes.editIcon} onClick={assignEmployeeFile}>
                                                            <Icon type="down" />
                                                        </IconButton>
                                                    </Tooltip>

                                                </Col>

                                                <Col span={12}>
                                                    <Tooltip disabled={rowSelectionAvailableFileAssig.length === 0} placement="bottom" title={'Designar colaborador'} onClick={removeEmployeeFile}>
                                                        <IconButton className={classes.editIcon} >
                                                            <Icon type="up" />
                                                        </IconButton>
                                                    </Tooltip>
                                                </Col>
                                            </Row>

                                            <Grid container direction="row">
                                                <Grid item xs={3}>
                                                    <TextEvents
                                                        text={'Colaboradores Asignados'}
                                                        color='cotemar'
                                                        size='label'
                                                        weight='bold'
                                                    />
                                                </Grid>
                                                <Grid item xs={9}>
                                                    <TextEvents
                                                        text={`${userAdd.length} ${userAdd.length === 1 ? "elemento" : "elementos"}`}
                                                        color='gray'
                                                    />
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Table
                                                        columns={columnsCategory}
                                                        dataSource={dataSourceFileAssig}
                                                        scroll={{ y: 150, /*x: 400*/ }}
                                                        rowSelection={rowSelectionAvailableFileAssig}
                                                        size="small"
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Paper>
                                    </TabPane>
                                </Tabs>
                            </Modal>
                        </Paper>

                    </TabPane>
                    <TabPane tab="Carga de Resultados" key='2'>
                        <Paper className={classes.paper}>
                            <OnSiteEvaluationsCalForm
                                filter={filterCal}
                                setFilter={setFilterCal}
                                setTab={setTabBar}
                                pagination={paginationCal}
                                sorter={sorterCal}
                                formData={formDataCal}
                                setFormData={setFormDataCal}
                            ></OnSiteEvaluationsCalForm>
                            <div style={styles.baseVerticalMargin}>
                                <OnSiteEvaluationsCalContainer
                                    classes={classes}
                                    setTab={setTabBar}
                                    filter={filterCal}
                                    sorter={sorterCal}
                                    setSorter={setSorterCal}
                                    pagination={paginationCal}
                                    setPagination={setPaginationCal}
                                    formData={formDataCal}
                                    setShowModal={showModalCal}
                                    setIdTest={setIdCal}
                                >
                                    {(params) => {
                                        return (
                                            <div>
                                                <Table
                                                    useFixedHeader={true}
                                                    loading={params.isLoading}
                                                    rowKey={item => String(item.idCommunication)}
                                                    columns={params.cols}
                                                    dataSource={params.evaluations}
                                                    onChange={params.handleTableChange}
                                                    pagination={paginationCal}
                                                    scroll={{ x: "min-content", y: (height - 395) }}
                                                    size={"small"}
                                                />
                                            </div>
                                        )
                                    }}
                                </OnSiteEvaluationsCalContainer>
                                <Modal
                                    visible={openCal}
                                    onCancel={() => setOpenCal(false)}
                                    width={'300px'}
                                    centered={true}
                                    footer={[
                                        <Button loading={evaluating} disabled={dateCal === ''} key="submit" type="primary" onClick={() => { saveEdition() }} >
                                            Guardar
                                        </Button>,
                                        <Button key="back"type="danger" ghost onClick={() => { succedCal() }}>
                                            Cancelar
                                        </Button>
                                    ]}

                                    title={<TextEvents
                                        text={titleCal}
                                        color='cotemar'
                                        size='label'
                                        weight='bold'
                                    />}
                                >
                                    <Grid>
                                        <Grid container direction='row'>
                                            <Grid item xs={12}>
                                                <TextEvents
                                                    text="Fecha Efectiva"
                                                    color="darker"
                                                    size="label"
                                                    weight="medium"
                                                />
                                                <DatePicker
                                                    format={'DD/MM/YYYY'}
                                                    onChange={(date, dateString) => {
                                                        setDateCal(dateString !== "" ? dateString.split('/').reverse().join('/') : '');
                                                        setDateRCal(date);
                                                    }}
                                                    placeholder="Seleccione Fecha"
                                                    value={dateCal !== "" ? moment(dateRCal) : ""}
                                                />
                                            </Grid>


                                        </Grid>
                                    </Grid>
                                </Modal>
                            </div>
                        </Paper>
                    </TabPane>
                </Tabs>
            </div>
        </div>
    )
}
